import React from 'react'
import { StyleSheet } from 'react-native'

import { DNAButton, DNABox } from "@alucio/lux-ui"
import { TitleBar } from 'src/components/DNA'
import { HubVariant, useHubsState } from 'src/state/context/Hubs/HubsStateProvider'
import { useAppSettings } from 'src/state/context/AppSettings'
import useFeatureFlags from 'src/hooks/useFeatureFlags/useFeatureFlags'
import { useHubTemplatesList } from 'src/state/redux/selector/hub'
import { useDispatch } from 'src/state/redux'
import { DNAModalActions, DNASelectTemplateModal } from 'src/components/DNA'

interface HubsTemplateHeaderProps {
  title: string
  description: string
}

/**
 * Reusable header component for hub templates with action buttons
 */
const HubsTemplateHeader: React.FC<HubsTemplateHeaderProps> = ({
  title,
  description,
}) => {
  const { deviceMode } = useAppSettings()
  const dispatch = useDispatch()
  const isHubTemplatesEnabled = useFeatureFlags('BEAC_6094_hubs_templates')
  const hideCreateHub = useFeatureFlags('BEAC_7952_hide_create_hub')
  const isTablet = deviceMode === 'tablet'
  const { variant, handleCreateTemplateInstance, handleCreateHubs } = useHubsState()
  const hubTemplatesORM = useHubTemplatesList()

  const createTemplateInstance = () => {
    dispatch(DNAModalActions.setModal({
      isVisible: true,
      allowBackdropCancel: true,
      component: (modalProps) => (
        <DNASelectTemplateModal
          {...modalProps}
          hubTemplatesORM={hubTemplatesORM}
          handleCreateTemplateInstance={handleCreateTemplateInstance}
          handleCreateHubs={handleCreateHubs}
        />
      ),
    }))
  }

  return (
    
      <TitleBar title={title} description={description} >
        {!hideCreateHub && (
          <TitleBar.Button>
            <DNAButton
              testID="hub-table-header-create-hub-btn"
              appearance="outline"
              status="primary"
              size={isTablet ? 'xl' : 'md'}
              onPress={handleCreateHubs}
              children={variant === HubVariant.TEMPLATE ? 'Create template' : 'Create hub'}
            />
          </TitleBar.Button>
        )}
        {isHubTemplatesEnabled && variant === HubVariant.STANDALONE && (
          <TitleBar.Button>
            <DNAButton
              testID="hub-table-header-create-template-btn"
              appearance="filled"
              status="primary"
              size={isTablet ? 'xl' : 'md'}
              onPress={createTemplateInstance}
              children="Create from template"
            />
          </TitleBar.Button>
        )}
    </TitleBar>
  )
}

export default HubsTemplateHeader
